import { themeConfig } from '@kmx/mui-resources';
import { createTheme } from '@mui/material/styles';
import deepmerge from '@mui/utils/deepmerge';

export default createTheme(
    deepmerge(themeConfig, {
        colorSchemes: { dark: false },
        components: {
            MuiCssBaseline: {
                styleOverrides: (theme: any) => {
                    const existingStyles = (themeConfig?.components ?? {})?.MuiCssBaseline?.styleOverrides;
                    const existingStylesString =
                        typeof existingStyles === 'function' ? existingStyles(theme) : existingStyles || '';

                    const newFontFace = `
                        @font-face {
                            font-display: swap;
                            font-family: 'RBRationalNeueCondensedBold';
                            font-style: normal;
                            font-weight: 700;
                            src:
                                url('https://www.carmax.com/shared/fonts/RBRationalNeueCondensed-Bold.woff2') format('woff2'),
                                url('https://www.carmax.com/shared/fonts/RBRationalNeueCondensed-Bold.woff') format('woff'),
                                url('https://www.carmax.com/shared/fonts/RBRationalNeueCondensed-Bold.ttf') format('truetype');
                        }
                    `;

                    return `${existingStylesString}${newFontFace}`;
                },
            },
        },
    }),
);
